import  TagAdapter from "../../../../core/Utils/Analytics/tagAdapter";
import { TagTypeGa4 } from "../../../../core/Utils/Analytics/tagType";

const callTagAdapter = (options) => {
    TagAdapter(options, TagTypeGa4.BUTTON_MODAL)
}

export default callTagAdapter;